export const ORDER_STATUS_SAVE = '提交';
export const ORDER_STATUS_GENERATE_DELIVERY = '已生成发货单';
export const ORDER_STATUS_CLOSE = '关闭';
export const ORDER_STATUS_LIQUDATED_DAMAGE = '违约';
export const ORDER_STATUS_CANCLE = '撤单';
export const ORDER_STATUS_DEAL = '已成交';
export const ORDER_STATUS_REMOVE = '取消';
export const ORDER_STATUS_MANUAL_CLOSE = '人工关闭';
export const ORDER_STATUS_EXPIRES_CLOSE = '超时关闭';

export const ORDER_PAID_STATUS_TYPE_UN_PAID = '未支付';
export const ORDER_PAID_STATUS_TYPE_TO_PAID = '定金待支付';
export const ORDER_PAID_STATUS_TYPE_DEPOSIT_PAID = '定金已支付';
export const ORDER_PAID_STATUS_TYPE_FULL_PAID = '全额支付';

//export const ORDER_DELIVERY_STATUS_TYPE_UN_SHIP = '未发货';
export const ORDER_DELIVERY_STATUS_TYPE_SHIP = '已发货';

export const ORDER_DETAIL_DELIVERY_TYPE_NONE = '未发货';
export const ORDER_DETAIL_DELIVERY_TYPE_FULL = '已发货';


export const ORDER_DELIVERY_STATUS_TYPE_UN_SUMBMIT = "未提交";
export const ORDER_DELIVERY_STATUS_TYPE_UN_SHIP = "未发货";
export const ORDER_DELIVERY_STATUS_TYPE_PART_SHIP = "部分发货";
export const ORDER_DELIVERY_STATUS_TYPE_ALL_SHIP = "全部发货";
export const ORDER_DELIVERY_STATUS_TYPE_RECEIVE = "已收货";
export const ORDER_DELIVERY_STATUS_TYPE_EARLYTERMINATION = "提前结束发货";


export const ORDER_REMARK_TYPE_CANCELED_DEPOSIT = "撤单";
export const ORDER_REMARK_TYPE_UPDATE = "修改";
export const ORDER_REMARK_TYPE_CANCELED_DELIVERY = "发货单撤单";
export const ORDER_REMARK_TYPE_CLOSE= "关闭";
export const ORDER_REMARK_TYPE_DELETESUBORDER="删除子单";
export const ORDER_REMARK_TYPE_LIQUIDATEDDAMAGE ="违约";
export const getOrderStatusOptions = () => {
    const status = [
        ORDER_STATUS_SAVE,
        ORDER_STATUS_GENERATE_DELIVERY,
        ORDER_STATUS_CANCLE,
        ORDER_STATUS_LIQUDATED_DAMAGE
        //ORDER_STATUS_CLOSE
    ];

    return status.map(s => {
        return { key: s, value: s };
    });
};

export const getOrderShipStatusOptions = () => {
    const status = [
    //    ORDER_DELIVERY_STATUS_TYPE_UN_SUMBMIT ,
        ORDER_DELIVERY_STATUS_TYPE_UN_SHIP,
        ORDER_DELIVERY_STATUS_TYPE_PART_SHIP,
        ORDER_DELIVERY_STATUS_TYPE_ALL_SHIP,
        ORDER_DELIVERY_STATUS_TYPE_EARLYTERMINATION
        //     ORDER_DELIVERY_STATUS_TYPE_RECEIVE 
    ];

    let reslut= status.map(s => {
        return { key: s, value: s };
    });
   
    // reslut.unshift({key:'无',value:''});

    return reslut;
};


export const getOrdeSplitStatusOptions = () => {
    let reslut = [
        { key: '未生成发货单', value: 0 },
        { key: '部分生成未提交', value: 10 },
        { key: '部分生成部分提交', value: 11 },
        { key: '部分生成全部提交', value: 12 },
        { key: '全部生成未提交', value: 20 },
        { key: '全部生成部分提交', value: 21 },
        { key: '全部生成全部提交', value: 22 }
    ];
    return reslut;
};

export const getOrderPaidStatusOptions = () => {
    const status = [
        ORDER_PAID_STATUS_TYPE_TO_PAID,
        ORDER_PAID_STATUS_TYPE_DEPOSIT_PAID,
        ORDER_PAID_STATUS_TYPE_FULL_PAID
    ];

    return status.map(s => {
        return { key: s, value: s };
    });
};

export const getOrderDeliveryStatusOptions = () => {
    const status = [
        ORDER_DELIVERY_STATUS_TYPE_UN_SHIP,
        ORDER_DELIVERY_STATUS_TYPE_SHIP
    ];

    return status.map(s => {
        return { key: s, value: s };
    });
};

export const getNoPaidDepositStatusOptions = () => {
    const status = [
        ORDER_STATUS_SAVE,
        ORDER_STATUS_REMOVE
    ];

    return status.map(s => {
        return { key: s, value: s };
    });
};
export const getOrderRemarkTypeOptions = () => {
    const status = [
        ORDER_REMARK_TYPE_CANCELED_DEPOSIT,
        ORDER_REMARK_TYPE_UPDATE,
        ORDER_REMARK_TYPE_CANCELED_DELIVERY,
        ORDER_REMARK_TYPE_CLOSE,
        ORDER_REMARK_TYPE_DELETESUBORDER,
        ORDER_REMARK_TYPE_LIQUIDATEDDAMAGE

    ];

    return status.map(s => {
        return { key: s, value: s };
    });
};
